import "../global/components/scroll-bar.css";

export function snap(device){

    const data = [
        {title: "9,000+", text: "Top remote and on-site jobs"},
        {title: "1,000+", text: "Company career pages"},
        {title: "1,000+", text: "Career life changing topics"},
    ];

    const styles = {
        snap: {
            display: 'flex',
        },
        snapItem:{
            flex: 1,
            background: '#fcfcfb',
            marginRight: 10,
            padding: '20px 10px',
            border: '1px solid #ccc',
            borderRadius: 3
        },
        snapTitle:{
            color: '#333',
            marginBottom: 3,
            fontSize: (device=="desktop")? 18: 16,
            fontWeight: 700 
        },
        snapText:{
            color: '#000',
            fontSize: (device=="desktop")? 14: 12,
        },
    }

    return (
        <div style={styles.snap}>
            {data.map(itm => (
                <div style={styles.snapItem}>
                    <h4 style={styles.snapTitle}>{itm.title}</h4>
                    <div style={styles.snapText}>{itm.text}</div>
                </div>
            ))}
        </div>
    )

}

export function testimonial(device){

    const data = [
        {img: "/images/testimonial/photo-1.png", name: "Suzzy Owase", info: "This site helped me land my dream job. I'm truly grateful for the opportunity!"},
        {img: "/images/testimonial/photo-2.png", name: "Wilson Bamidele", info: "Thanks to the daily career updates, I stayed ahead in my work place!"}
    ];

    const styles = {
        desktop:{
            testimony:{
                
            },
            item:{
                marginBottom: 10,
                paddingTop: 35, //to compensate for the photo
            },
            body:{
                flexGrow: 0,
                flexShrink: 0,
                paddingTop: 30,
                paddingLeft: 15,
                paddingRight: 15,
                paddingBottom: 15,
                border: '1px solid #ccc',
                borderRadius: 5,
                textAlign: 'left',
                position: 'relative',
                zIndex: 99
            },
            photo: {
                position: 'absolute',
                top: -33,
                left: 20,
                zIndex: 9999
            },
            img: {
                width: 60
            },
            name:{
                marginBottom: 3,
                fontSize: 16,
                fontWeight: 600
            },
            info:{
                fontSize: 14
            }
        },
        mobile:{
            testimony:{
                display: 'flex',
                overflowY: 'scroll',
                paddingTop: 40
            },
            item:{
                width: '280px',
                flexGrow: 0,
                flexShrink: 0,
                marginRight: 20,
                paddingTop: 30,
                paddingLeft: 15,
                paddingRight: 15,
                paddingBottom: 10,
                border: '1px solid #ccc',
                borderRadius: 5,
                textAlign: 'left',
                position: 'relative',
                zIndex: 99
            },
            photo: {
                position: 'absolute',
                top: -25,
                left: 20,
                zIndex: 9999
            },
            img: {
                width: 50
            },
            name:{
                marginBottom: 3,
                fontSize: 16,
                fontWeight: 600
            },
            info:{
                fontSize: 14
            }
        }
    }

    if(device == "desktop"){
        return (
            <div style={styles.desktop.testimony}>
                {data.map(itm => (
                    <div style={styles.desktop.item}>
                        <div style={styles.desktop.body}>
                            <div style={styles.desktop.photo}>
                                <img src={itm.img} style={styles.desktop.img} />
                            </div>
                            <div>
                                <h4 style={styles.desktop.name}>{itm.name}</h4>
                                <div style={styles.desktop.info}>{itm.info}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
    else if(device == "mobile"){
        return (
            <div style={styles.mobile.testimony} className='hide-scroll-bar'>
                {data.map(itm => (
                    <div style={styles.mobile.item}>
                        <div style={styles.mobile.photo}>
                            <img src={itm.img} style={styles.mobile.img} />
                        </div>
                        <div>
                            <h4 style={styles.mobile.name}>{itm.name}</h4>
                            <div style={styles.mobile.info}>{itm.info}</div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

} 